import { GoogleGenerativeAI } from '@google/generative-ai';
import { handleGoogleAIError } from './error-handlers';

const genAI = new GoogleGenerativeAI(process.env.REACT_APP_GOOGLE_AI_API_KEY);

export async function identifyPlant(imageData) {
  try {
    // Validate image data
    if (!imageData || !imageData.includes('base64')) {
      throw new Error('Invalid image data provided');
    }

    const model = genAI.getGenerativeModel({ model: 'gemini-1.5-flash' });

    const prompt = `
      First, confirm if this image contains a plant. If it does NOT contain a plant, respond with exactly "NO_PLANT".
      
      If it DOES contain a plant, analyze it and provide information in this exact format:

      1. Common and Scientific Name: [Common name] ([Scientific name])
      2. Brief Description: [2-3 sentences about the plant]
      3. Key Characteristics for Identification: [List 3-4 key features]
      4. Basic care requirements: [Light, water, and soil needs]
      5. Any special notes or warnings: [Important care notes or toxicity warnings]

      If you're not completely sure about the identification, start with "Note: This is a tentative identification."
      Keep responses concise and focused.
    `.trim();

    const result = await model.generateContent([
      prompt,
      {
        inlineData: {
          mimeType: 'image/jpeg',
          data: imageData.split(',')[1]
        }
      }
    ]);

    if (!result?.response) {
      throw new Error('No response from AI service');
    }

    const response = await result.response;
    const text = response.text();

    // Check if the image doesn't contain a plant
    if (text.includes('NO_PLANT')) {
      throw new Error(
        'No plant detected in the image. Please upload an image containing a plant.'
      );
    }

    if (!text || text.trim() === '') {
      throw new Error(
        'Unable to identify plant. Please try with a clearer image.'
      );
    }

    return text;
  } catch (error) {
    const errorMessage = handleGoogleAIError(error);
    throw new Error(errorMessage);
  }
}
